<template>
  <div>
   <el-select v-model="currentProvince" filterable>
      <el-option
        v-for="item in provinces"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select >
    <ECharts :options="provinceChartOptions" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import echarts from 'echarts';
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import _ from 'lodash';

@Component({
  components: { ECharts }
})
export default class ProvinceEchart extends Vue {
  @Prop(Object) data;
  @Prop(String) titleText;
  @Prop(Object) seriesName;

  currentProvince = 'guangdong';

  provinces = [
    { value: 'guangdong', label: '广东省', cities: [] },
    { value: 'zhejiang', label: '浙江省', cities: [] },
    { value: 'jiangsu', label: '江苏省', cities: [] },
    { value: 'sichuan', label: '四川省', cities: [] },
    { value: 'shandong', label: '山东省', cities: [] },
    { value: 'hubei', label: '湖北省', cities: [] },
    { value: 'hunan', label: '湖南省', cities: [] },
    { value: 'jiangxi', label: '江西省', cities: [] },
    { value: 'fujian', label: '福建省', cities: [] },
    { value: 'guangxi', label: '广西', cities: [] },
    { value: 'henan', label: '河南省', cities: [] },
    { value: 'hebei', label: '河北省', cities: [] },
    { value: 'liaoning', label: '辽宁省', cities: [] },
    { value: 'yunnan', label: '云南省', cities: [] },
    { value: 'shanxi', label: '山西省', cities: [] },
    { value: 'guizhou', label: '贵州省', cities: [] },
    { value: 'anhui', label: '安徽省', cities: [] },
    { value: 'shanxi1', label: '陕西省', cities: [] },
    { value: 'heilongjiang', label: '黑龙江省', cities: [] },
    { value: 'neimenggu', label: '内蒙古', cities: [] },
    { value: 'jilin', label: '吉林省', cities: [] },
    { value: 'gansu', label: '甘肃省', cities: [] },
    { value: 'hainan', label: '海南省', cities: [] },
    { value: 'xianggang', label: '香港', cities: [] },
    { value: 'qinghai', label: '青海省', cities: [] },
    { value: 'xinjiang', label: '新疆', cities: [] },
    { value: 'chongqing', label: '重庆', cities: [] },
    { value: 'xizang', label: '西藏', cities: [] }
  ]

  mounted() {
    this.provinces.forEach(item => {
      // 引入中国省级地图数据
      const province = require(`echarts/map/json/province/${item.value}.json`);
      echarts.registerMap(item.value, province);
      item.cities = province.features.map(ele => ele.properties.name);
    })
  }

  get seriesData() {
    return _.result(_.find(this.provinces, (item) => item.value === this.currentProvince), 'cities').map((city => {
      return {
        name: city,
        value: _.result(_.find(this.data, (item) => city.includes(item.name) || item.name.includes(city)), 'value') || 0
      };
    }))
  }

  get provinceChartOptions() {
    return ({
      tooltip: {
        trigger: 'item',
        formatter: '{a}<br/>{b}：{c}'
      },
      title: {
        text: this.titleText,
        left: '0',
        top: '5%',
        textStyle: {
          color: '#ccc'
        }
      },
      visualMap: {
        left: '0',
        min: 0,
        max: 100,
        inRange: {
          color: ['#f7fffa', '#98efbc', '#79e0a4', '#5cca8a', '#4db779', '#43a56b', '#3a945f']
        },
        text: ['高', '低'],
        calculable: true
      },
      toolbox: {
        show: true,
        left: 'right',
        top: '5%',
        feature: {
          dataView: { readOnly: true },
          saveAsImage: {}
        }
      },
      series: [
        {
          name: this.seriesName,
          type: 'map',
          roam: true,
          map: this.currentProvince,
          emphasis: {
            lable: { show: true }
          },
          data: this.seriesData,
        }
      ]
    })
  }
}
</script>
